import { Box, Dialog, DialogContent } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

type ImageModalProps = {
  imageSrc: string;
  open: boolean;
  handleClose: Dispatch<SetStateAction<boolean>>;
  onImagePress?: () => void;
};

const ImageModal = ({ imageSrc, open, handleClose, onImagePress }: ImageModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: { backgroundColor: "transparent", elevation: 0, boxShadow: "none" } }}
      style={{ width: "100%", height: "100%" }}
    >
      <DialogContent>
        <Box
          height="100%"
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          padding={0.5}
          overflow="hidden"
        >
          <img
            onClick={onImagePress ? onImagePress : () => {}}
            src={imageSrc}
            alt="question modal"
            style={{
              objectFit: "contain",
              borderRadius: "10px",
              height: "400px",
              width: "800px",
              maxWidth: "100%",
              maxHeight: "100%",
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImageModal;
